import { render, staticRenderFns } from "./WidgetsTotal.vue?vue&type=template&id=3943812a&"
import script from "./WidgetsTotal.vue?vue&type=script&lang=js&"
export * from "./WidgetsTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports